(function($) {
    // Initialise block and run functions in Gutenberg Editor
    var initBlock = function ($block) {
        inner_block_image_slider();
    }

    // Initialize dynamic block preview (editor)
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=sc-inner-block-image-slider', initBlock);
    }

    // Frontend functions
    $(function() {
        inner_block_image_slider();
    });
    
    function inner_block_image_slider() {
        var $sliderContainer = jQuery('.image-slider-container');
    
        $sliderContainer.each(function (index, item) {
            var $container = jQuery(this),
                $slider = $container.find('.slider').addClass('slider-' + index),
                $controls = $container.find('.slider-controls'),
                $dots = $container.find('.slider-dots'),
                dots = true,
                infinite = true,
                slidesToShow = 1,
                slidesToScroll = 1,
                arrows = false,
                autoplay = false
            ;
    
            // Numbered Arrows //
            if ($container.hasClass('arrows')) {
                arrows = true;
    
                // jQuery('.slider-' + index).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                //     var i = (currentSlide ? currentSlide : 0) + 1;
                //     jQuery('.slide-info', slick.$slider.parent()).html(i + '<span>/</span>' + slick.slideCount);
                // });
            }
    
            // Autoplay //
            if ($container.hasClass('auto')) {
                autoplay = true;
            }
            
            $slider.not('.slick-initialized').slick({
                slidesToShow: slidesToShow,
                slidesToScroll: slidesToScroll,
                dots: dots,
                arrows: arrows,
                autoplay: autoplay,
                infinite: infinite,
                appendDots: $dots,
                appendArrows: $controls,
                autoplaySpeed: 5000,
                prevArrow:
                    '<a class="slick-prev"><span class="icon"><i class="fal fa-chevron-left"></i></span></a>',
                nextArrow:
                    '<a class="slick-next"><span class="icon"><i class="fal fa-chevron-right"></i></span></a>'
            });
        });
    }
})(jQuery);